import React from "react";
import "../styles/Footer.css";
import { FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-social">
          <a href="https://github.com/" target="_blank" rel="noopener noreferrer" className="social-link disabled">
            <FaGithub className="social-icon" />
          </a>
          <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" className="social-link disabled">
            <FaLinkedin className="social-icon" />
          </a>
          <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" className="social-link disabled">
            <FaInstagram className="social-icon" />
          </a>
        </div>

        <ul className="footer-links">
          <li><a href="/">Startseite</a></li>
          <li><a href="#about">Über mich</a></li>
          <li><a href="#projects">Projekte</a></li>
          <li><a href="#contact">Kontakt</a></li>
          <li><a href="/impressum" className="disabled-link">Impressum</a></li>
          <li><a href="/datenschutz">Datenschutz</a></li>
        </ul>

        <p className="footer-copyright">
          © {new Date().getFullYear()} Adrian Weiner | Alle Rechte vorbehalten.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
